import { createRouter, createWebHistory } from "vue-router";
import { isAuthenticated } from '@/utils/auth.js';
import NavBar from "@/components/NavBar.vue";
import {inject} from 'vue';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: "/",
            name: "flux-forecast",
            components: {
                default: () => import("@/components/home/HomePage.vue"),
                NavBar,
            },
        },
        {
            path: "/reports",
            name: "reports",
            components: {
                default: () => import("@/components/report/ReportPage.vue"),
                NavBar,
            },
        },
        {
            path: "/history",
            name: "history",
            components: {
                default: () => import("@/components/history/HistoryPage.vue"),
                NavBar,
            },
        },
        {
            path: "/settings",
            name: "settings",
            components: {
                default: () => import("@/components/settings/SettingsPage.vue"),
                NavBar,
            },
        },
        {
            path: "/methodology",
            name: "methodology",
            components: {
                default: () => import("@/components/methodology/MethodologyPage.vue"),
                NavBar,
            },
        },
        {
            path: '/login',
            name: 'login',
            components: {
                default: () => import('@/components/auth/LoginPage.vue'),
            },
        },
        {
            path: '/forgot',
            name: 'forgot',
            components: {
                default: () => import('@/components/auth/ForgotPassword.vue'),
            },
        },
        {
            path: '/demo',
            name: 'demo',
            components: {
                default: () => import('@/components/auth/DemoLanding.vue'),
            },
        },
        {
            path: '/subscribe',
            name: 'subscribe',
            components: {
                default: () => import('@/components/auth/SubscribePage.vue'),
            }
        },
        {
            path: '/new-password',
            name: 'new-password',
            components: {
                default: () => import('@/components/auth/NewPasswordPage.vue'),
            }
        }
    ]
})

// if you need to know the previous page you can use (to, from) => {}
router.beforeEach( async (to) => {
    const deepState = inject('deepState');
    let queryString = deepState.stateString();
    if (queryString) {
        queryString =`?${queryString}`
    }
    if(!to.fullPath.includes(queryString)) {
        to.fullPath = `${to.path}${queryString}`;
    }
    if (!isAuthenticated() && !( ['/login', '/forgot', '/demo', '/new-password'].includes(to.path) )) {
        return `/login${queryString}`;
    }
})

export default router;
